module.exports = __webpack_public_path__ + "static/media/Ranking.13573262.png";